<template>
    <div class="gallery-groups">
        <div class="gallery-group" v-loading="loading">
                <div class="header-group"> 
                    <div class="header-upload">
                        <el-upload
                            :action="imgLoadPath"
                            :show-file-list="false"
                            :on-error="handleError"
                            :on-success="handleBeforeUpload1"
                            :before-upload="beforeUpload"
                            :headers="{'yj-admin-token':token}"
                            :data="{coachId}"
                        >
                            <el-button size="medium" type="primary">上传<i class="el-icon-upload el-icon--right"></i></el-button>
                        </el-upload>
                        <span style="font-size:12px;white-space: nowrap;">(图片格式:jpg、jpeg、png)</span>
                        <!-- <span class="hall-search-name">教练选择：</span>
                        <el-select v-model="coachId" placeholder="请选择" @change="initMetod">
                            <el-option value="" label="全部"></el-option>
                            <el-option
                                v-for="item in coachesData"  
                                :key="item.id"
                                :label="item.coachName"
                                :value="item.id">
                            </el-option>
                        </el-select> -->
                    </div>
                </div>
                <div class="gallery-content Scrollbars-box"> 
                    <div class="gallery-container">
                        <div class="gallery-img-box" v-for="(item,index) in imgLists" :key="index">
                            <div class="gallery-img-item">
                                <div class="gallery-img-cover"  @click="showBigImg(index)">
                                    <img style="width: 100%; height: 160px" :src="item.coverUrl" alt="">
                                    <div class="gallery-img-hover">查看大图</div>
                                </div>
                                <div class="gallery-img-fun">
                                    <el-popconfirm title="确定删除吗？" @confirm="deleta(item,index)">
                                        <el-button slot="reference" type="text" style="color:red;" icon="el-icon-delete">删除</el-button>
                                    </el-popconfirm>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>    
            </div>
        <el-image-viewer
            v-if="dialogVisible"
            :zIndex="9999"
            :on-close="()=>dialogVisible=false"
            :url-list="imgList"
            :initial-index="imgIndex"
        />
        <el-empty description="还没有内容" v-if="imgLists.length==0"></el-empty>
    </div>
</template>

<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
export default {
    name: 'course_live_background',
    components:{ElImageViewer},
    data() { 
        return {
            url:'',
            activeName: '1',
            loading:false,
            dialogShow:false,
            dialogVisible:false,
            docLoadPath: '',
            uploadLogin: null,
            imgLists:[],
            imgList:[],
            imgLoadPath:process.env.API_ROOT+'/courseCover/live/background',
            coachId:'',
            coachesData:[],
            token:localStorage.getItem("token")
        };
    },
    mounted(){
        // const sysRoleId=window.localStorage.getItem('sysRoleId');
        // const userId=window.localStorage.getItem('userId');
        // if(sysRoleId && this.$_.isString(sysRoleId) && sysRoleId==6){
        //     this.coachId=this.$_.isNumber(Number(userId))?Number(userId):'';
        // }
        // this.selCoachesData()
        this.initMetod();
        
    },
    methods: {
         //选择教练
        selCoachesData() {
            this.$get('/coaches', {pageNum:1,limit:1000})
                .then(res => {
                    if (res.code == 0) {
                        let list = Array.isArray(res.data.list)?res.data.list:[];
                        this.coachesData=list;
                    } else {
                        this.$message.error(res.message);
                    }
                })
                .catch(() => {
                    console.log();
                });
        },
        showBigImg(index){
            this.imgIndex=index;
            this.dialogVisible=true;
        }, 
        deleta(data,index){
            this.loading=true;
            this.$delete(`/courseCover/delete/${data.id}`).then((res) => {
                console.log('res',res);
                if (res.code == 0) {
                    console.log(res);
                    this.$message.success('操作成功');
                    this.imgLists.splice(index,1)
                } else {
                    this.$message.error(JSON.stringify(res.message));
                }
                 this.loading=false;
            }).catch(err=>{
                this.$message.error(JSON.stringify(err));
                this.loading=false;
            })
        },
        initMetod(){
           this.loading=true;
            this.$get('/courseCover/list', {coverType:this.activeName,coachId:this.coachId}).then((res) => {
                console.log('res',res);
                if (res.code == 0) {
                    console.log(res);
                    let list=Array.isArray(res.data)?res.data:[]
                    this.imgLists=list
                    this.imgList=list.map(item=>item.coverUrl);
                } else {
                    this.$message.error(JSON.stringify(res.message));
                }
                 this.loading=false;
            }).catch(err=>{
                this.$message.error(JSON.stringify(err));
                this.loading=false;
            })
        },
        dialogClose(){
            this.$emit('update:dialog', false);
        },
        handleBeforeUpload1(response) {
           this.loading=false;
            if (response.code == 0) {
                this.$message.success('上传成功');
                this.initMetod()
            } else {
                this.$message.error(response.message);
            }
        },
        beforeUpload: function (file) {
            var FileExt = file.name.replace(/.+\./, '');
            if (['jpg', 'jpeg', 'png'].indexOf(FileExt.toLowerCase()) === -1) {
                this.$message({
                    type: 'warning',
                    message: '请上传jpg,jpeg,png格式文件！'
                });
                return false;
            }
            this.loading=true;
        },
        handleError(){
            this.loading=false;
            this.$message.error('上传失败');
        },
    }
};
</script>

<style scoped>

.header-group{
   padding:10px;
   display: flex;
   align-items: center;
} 
.gallery-content{
    height: 100%;
}
.gallery-container{
    display: flex;
    align-content: flex-start;
    flex-wrap: wrap;
} 
.gallery-img-box{
    width: 12.5%;
    padding:10px;
} 
.gallery-img-item{
    background: #ffffff;
    box-shadow: 0 12px 20px 0 rgba(0,0,0,.2);
    border-radius: 6px;
    overflow: hidden;
    font-size: 0;
} 
.gallery-img-fun{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.gallery-img-cover{
    position: relative;
    cursor: pointer;
}
.gallery-img-cover:hover .gallery-img-hover{
    display: flex;
}
.gallery-img-hover{
  position: absolute;
  top:0;
  left:0;
  bottom:0;
  right: 0;
  display: none;
  align-items: center;
  justify-content: center;
  background: rgba(0,0,0,.6);
  font-size: 16px;
  color:#fff;
  z-index: 99;
}
.header-upload{
    display: flex;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/backgroundImg/course_live_background.vue